/* Guest Pages */
const Guest = () => import(/* webpackChunkName: "guest" */ '@/pages/guest/Guest.vue')
const SignIn = () => import(/* webpackChunkName: "signin" */ '@/pages/guest/SignIn.vue')
const ForgotPassword = () => import(/* webpackChunkName: "forgot-password" */ '@/pages/guest/ForgotPassword.vue')
const ChangePassword = () => import(/* webpackChunkName: "change-password" */ '@/pages/guest/ChangePassword.vue')

/* Authenticated Pages */
const Auth = () => import(/* webpackChunkName: "auth" */ '@/pages/auth/Auth.vue')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/pages/auth/Dashboard.vue')
const Users = () => import(/* webpackChunkName: "users" */ '@/pages/auth/Users.vue')
const UserProfile = () => import(/* webpackChunkName: "user-profile" */ '@/pages/auth/UserProfile.vue')
const NotificationPost = () => import(/* webpackChunkName: "notification-post" */ '@/pages/auth/NotificationPost.vue')
const CreateNotification = () => import(/* webpackChunkName: "create-notification" */ '@/pages/auth/CreateNotification.vue')
const EditNotification = () => import(/* webpackChunkName: "edit-notification" */ '@/pages/auth/EditNotification.vue')
const NewsfeedPost = () => import(/* webpackChunkName: "newsfeed-post" */ '@/pages/auth/NewsfeedPost.vue')
const CreateNewsfeed = () => import(/* webpackChunkName: "create-newsfeed" */ '@/pages/auth/CreateNewsfeed.vue')
const EditNewsfeed = () => import(/* webpackChunkName: "edit-newsfeed" */ '@/pages/auth/EditNewsfeed.vue')
const AddSubtags = () => import(/* webpackChunkName: "add-subtags" */ '@/pages/auth/AddSubtags.vue')
const Orders = () => import(/* webpackChunkName: "orders" */ '@/pages/auth/Orders.vue')
// const Stickers = () => import(/* webpackChunkName: "stickers" */ '@/pages/auth/Stickers.vue')
// const ViewStickers = () => import(/* webpackChunkName: "view-stickers" */ '@/pages/auth/ViewStickers.vue')
// const AddStickers = () => import(/* webpackChunkName: "add-stickers" */ '@/pages/auth/AddStickers.vue')
// const UpdateStickers = () => import(/* webpackChunkName: "update-stickers" */ '@/pages/auth/UpdateStickers.vue')
const Messages = () => import(/* webpackChunkName: "messages" */ '@/pages/auth/Messages.vue')

const GenerateReport = () => import(/* webpackChunkName: "generate-report" */ '@/pages/auth/GenerateReport.vue')

export default [
	...middleware('guest', [
		{
			path: '/',
			component: Guest,

			children: [
				{
					path: '/',
					name: 'signin',
					component: SignIn
				},

				{
					path: '/forgot-password',
					name: 'forgot-password',
					component: ForgotPassword
				},

				{
					path: '/change-password',
					name: 'change-password',
					component: ChangePassword
				}
			]
		}
	]),

	...middleware('auth', [
		{
			path: '/',
			component: Auth,
			redirect: '/dashboard',

			children: [
				{
					path: '/dashboard',
					name: 'dashboard',
					component: Dashboard,
					meta: {
						title: 'Dashboard'
					}
				},

				{
					path: '/users',
					name: 'users',
					component: Users,
					meta: {
						title: 'Users'
					}
				},

				{
					path: '/user-profile/:id',
					name: 'user-profile',
					component: UserProfile,
					props: true,
					meta: {
						title: 'User Profile',
						origin: [{ name: 'users', text: 'Users' }]
					}
				},

				{
					path: '/notification-post',
					name: 'notification-post',
					component: NotificationPost,
					meta: {
						title: 'Notification Posts'
					}
				},

				{
					path: '/notification-post/create',
					name: 'create-notification',
					component: CreateNotification,
					meta: {
						title: 'Create Notification',
						origin: [{ name: 'notification-post', text: 'Notification Posts' }]
					}
				},

				{
					path: '/notification-post/edit/:notificationId',
					name: 'edit-notification',
					component: EditNotification,
					props: true,
					meta: {
						title: 'Edit Notification',
						origin: [{ name: 'notification-post', text: 'Notification Posts' }]
					}
				},

				{
					path: '/newsfeed-post',
					name: 'newsfeed-post',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/create',
					name: 'create-newsfeed',
					component: CreateNewsfeed,
					meta: {
						title: 'Create Newsfeed',
						origin: [{ name: 'newsfeed-post', text: 'Newsfeed Posts' }]
					}
				},

				{
					path: '/newsfeed-post/edit',
					name: 'edit-newsfeed',
					component: EditNewsfeed,
					meta: {
						title: 'Edit Newsfeed',
						origin: [{ name: 'newsfeed-post', text: 'Newsfeed Posts' }]
					}
				},

				{
					path: '/newsfeed-post/main',
					name: 'newsfeed-post-main',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/mid',
					name: 'newsfeed-post-mid',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/subtags',
					name: 'newsfeed-post-subtags',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/drafts',
					name: 'newsfeed-post-drafts',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/archives',
					name: 'newsfeed-post-archives',
					component: NewsfeedPost,
					meta: {
						title: 'Newsfeed Posts'
					}
				},

				{
					path: '/newsfeed-post/add-subtags',
					name: 'newsfeed-post-add-subtags',
					component: AddSubtags,
					meta: {
						title: 'Add Subtags'
					}
				},

				{
					path: '/orders',
					name: 'orders',
					component: Orders,
					meta: {
						title: 'Orders'
					}
				},

				// {
				// 	path: '/stickers',
				// 	name: 'stickers',
				// 	component: Stickers,
				// 	meta: {
				// 		title: 'Stickers'
				// 	}
				// },
				// {
				// 	path: '/stickers/:name',
				// 	name: 'view-stickers',
				// 	component: ViewStickers,
				// 	props: true,
				// 	meta: {
				// 		title: 'View Stickers',
				// 		origin: [{ name: 'stickers', text: 'Sticker' }]
				// 	}
				// },

				// {
				// 	path: '/sticker/add-stickers',
				// 	name: 'add-stickers',
				// 	component: AddStickers,
				// 	meta: {
				// 		title: 'Add Stickers',
				// 		origin: [{ name: 'stickers', text: 'Sticker' }]
				// 	}
				// },

				// {
				// 	path: '/sticker/:name/update',
				// 	name: 'update-stickers',
				// 	component: UpdateStickers,
				// 	meta: {
				// 		title: 'Update Stickers',
				// 		origin: [{ name: 'stickers', text: 'Sticker' }]
				// 	}
				// },

				{
					path: '/messages',
					name: 'messages',
					component: Messages,
					meta: {
						title: 'Messages'
					}
				}
			]
		},

		{
			path: '/generate-report',
			name: 'generate-report',
			component: GenerateReport
		}
	])
]

function middleware (middleware, routes) {
	routes.forEach(route =>
		(route.middleware || (route.middleware = [])).unshift(middleware)
	)

	return routes
}
